export default __webpack_public_path__ + "static/media/08_tag_hot-spring.b236fb48.svg";